/*
 LANGUAGE FILE FOR GERMAN LANG
 */

export default {
  message: {
    hello : 'hello world'
  },
  "An image copied from Word or Excel could not be pasted. Copy the image on its own, or save it as a file and insert it from there.":
      "Ein aus Word oder Excel kopiertes Bild konnte nicht eingefügt werden. Kopieren Sie das Bild einzeln oder speichern Sie es als Datei und fügen Sie es von dort ein.",
  "You cannot log in as this user, because they have permissions you do not have yourself:": "Du kannst dich nicht als dieser Benutzer anmelden, weil er Berechtigungen hat, die du selbst nicht hast:",
  "Your role needs these permissions too. They are set under Permission groups.": "Deine Rolle braucht diese Berechtigungen ebenfalls. Sie werden unter Rollen festgelegt.",
  "Edaptio super administrator": "Edaptio-Superadministrator",
  "at another institution": "an einer anderen Institution",
  "Download PDF": "PDF herunterladen",
  "Creating PDF…": "PDF wird erstellt…",
  "The PDF could not be created. Try again.": "Die PDF konnte nicht erstellt werden. Bitte erneut versuchen.",
  "Hand-ins are closed for this class. Please contact your teacher.": "Die Abgabe ist für diese Klasse geschlossen. Bitte wende dich an deine Lehrkraft.",
  "The deadline has passed and late hand-in is closed for you on this assignment.": "Die Frist ist abgelaufen und die verspätete Abgabe ist für dich bei dieser Aufgabe gesperrt.",
  "This assignment is not available to you.": "Diese Aufgabe steht dir nicht zur Verfügung.",
  "Your hand-in could not be submitted. Please try again, or contact your teacher.": "Deine Abgabe konnte nicht gesendet werden. Bitte versuche es erneut oder wende dich an deine Lehrkraft.",
  "You have already handed this assignment in.": "Du hast diese Aufgabe bereits abgegeben.",
  "Add": "Hinzufügen",
  "Adding": "Wird hinzugefügt",
  "Try again": "Erneut versuchen",
  "Finish quiz": "Quiz beenden",
  "Allow repeating single questions": "Wiederholung einzelner Fragen zulassen",
  "Only available when the quiz is not a Test": "Nur verfügbar, wenn das Quiz kein Test ist",
  "When on, a learner who answers a question incorrectly can retry that single question instead of repeating the whole quiz.": "Wenn aktiviert, kann ein/e Lernende/r bei einer falsch beantworteten Frage genau diese Frage erneut versuchen, anstatt das ganze Quiz zu wiederholen.",
  "Block late submission for this student": "Verspätete Abgabe für diese/n Kursteilnehmer/in sperren",
  "Allow late submission for this student": "Verspätete Abgabe für diese/n Kursteilnehmer/in erlauben",
  "Late submission is closed for this student": "Verspätete Abgabe ist für diese/n Kursteilnehmer/in gesperrt",
  "Late submission is open for this student": "Verspätete Abgabe ist für diese/n Kursteilnehmer/in freigegeben",
  "Something went wrong": "Etwas ist schiefgelaufen",
  "Camera is not available in this browser": "Die Kamera ist in diesem Browser nicht verfügbar",
  "Camera permission denied": "Kamerazugriff verweigert",
  "Cancel": "Abbrechen",
  "Cancelled": "Abgebrochen",
  "Capture failed": "Aufnahme fehlgeschlagen",
  "Captured photo": "Aufgenommenes Foto",
  "Click record to capture audio with your microphone.":
    "Klicken Sie auf „Aufnehmen“, um Audio mit Ihrem Mikrofon aufzunehmen.",
  "Close": "Schließen",
  "Connect": "Verbinden",
  "Connect Google Drive": "Google Drive verbinden",
  "Connect OneDrive Personal": "OneDrive Personal verbinden",
  "Connect OneDrive for Business": "OneDrive for Business verbinden",
  "Connected as": "Verbunden als",
  "Could not fetch URL": "URL konnte nicht abgerufen werden",
  "Could not open Google Drive": "Google Drive konnte nicht geöffnet werden",
  "Done": "Fertig",
  "Files": "Dateien",
  "Google Drive is not configured for this environment.":
    "Google Drive ist für diese Umgebung nicht konfiguriert.",
  "Import from a URL": "Von einer URL importieren",
  "Importing files": "Dateien werden importiert",
  "Loading": "Wird geladen",
  "OneDrive Personal needs the legacy OneDrive API permission on the Azure app registration. Add the OneDrive API (app id 6a9b9266-…) with the OneDrive.ReadWrite delegated permission and grant admin consent.":
    "OneDrive Personal benötigt die ältere OneDrive-API-Berechtigung in der Azure-App-Registrierung. Fügen Sie die OneDrive-API (App-ID 6a9b9266-…) mit der delegierten Berechtigung OneDrive.ReadWrite hinzu und erteilen Sie die Administratorzustimmung.",
  "OneDrive is not configured for this environment.":
    "OneDrive ist für diese Umgebung nicht konfiguriert.",
  "Open Google Drive": "Google Drive öffnen",
  "Open OneDrive": "OneDrive öffnen",
  "Paste a public link and we will fetch the file straight into your Edaptio uploads.":
    "Fügen Sie einen öffentlichen Link ein, und wir laden die Datei direkt in Ihre Edaptio-Uploads.",
  "Pick from Google Drive": "Aus Google Drive auswählen",
  "Pick from OneDrive Personal": "Aus OneDrive Personal auswählen",
  "Pick from OneDrive for Business": "Aus OneDrive for Business auswählen",
  "Popup blocked — allow popups for this site.":
    "Pop-up blockiert – erlauben Sie Pop-ups für diese Website.",
  "Preview your photo": "Foto-Vorschau",
  "Preview your recording": "Aufnahme-Vorschau",
  "Record audio": "Audio aufnehmen",
  "Retake": "Erneut aufnehmen",
  "Select files to upload": "Dateien zum Hochladen auswählen",
  "Sign in with Google to pick files straight from your Drive.":
    "Melden Sie sich mit Google an, um Dateien direkt aus Ihrem Drive auszuwählen.",
  "Sign in with your personal Microsoft account (@outlook.com, @hotmail.com, @live.com).":
    "Melden Sie sich mit Ihrem persönlichen Microsoft-Konto an (@outlook.com, @hotmail.com, @live.com).",
  "Sign in with your school or work Microsoft account to pick files from OneDrive for Business.":
    "Melden Sie sich mit Ihrem Schul- oder Geschäfts-Microsoft-Konto an, um Dateien aus OneDrive for Business auszuwählen.",
  "Switch account": "Konto wechseln",
  "Take Photo": "Foto aufnehmen",
  "This Microsoft account does not have OneDrive for Business. Ask your IT admin to enable SharePoint Online for the tenant.":
    "Dieses Microsoft-Konto verfügt nicht über OneDrive for Business. Bitten Sie Ihren IT-Administrator, SharePoint Online für den Mandanten zu aktivieren.",
  "This is a personal Microsoft account. Use the \"OneDrive Personal\" tab instead.":
    "Dies ist ein persönliches Microsoft-Konto. Verwenden Sie stattdessen die Registerkarte „OneDrive Personal“.",
  "Upload": "Hochladen",
  "Upload failed": "Hochladen fehlgeschlagen",
  "Upload source": "Upload-Quelle",
  "done": "fertig",
  "failed": "fehlgeschlagen",
  "or drag and drop here": "oder hierher ziehen und ablegen",
  "font_size.normal": "Normal",
  "font_size.medium": "Mittel",
  "font_size.large": "Groß",
  "font_size.extra_large": "Extra groß",
  "font_size.xxl": "XXL",
  "font_size.huge": "Riesig",
  "Fix Student Record": "Studentendatensatz reparieren",
  "Fix UMS students": "UMS-Studenten reparieren",
  "Fix UMS Students": "UMS-Studenten reparieren",
  "Fix UMS students description": "Geben Sie eine Studentenverwaltungs-ID ein, um Studentendaten aus dem Universitätsverwaltungssystem zu reparieren und zu synchronisieren.",
  "Clean up a class against UMS/Ludus": "Eine Klasse mit UMS/Ludus abgleichen",
  "Find the class, see who is enrolled in Edaptio but no longer on the hold in UMS/Ludus, and move them to dropped-out students.": "Klasse suchen, sehen wer in Edaptio eingeschrieben ist aber nicht mehr im Kurs in UMS/Ludus steht, und diese zu den abgemeldeten Teilnehmern verschieben.",
  "Search for a class": "Nach einer Klasse suchen",
  "e.g. 4F11D or Dansk": "z. B. 4F11D oder Dansk",
  "Search": "Suchen",
  "No classes found": "Keine Klassen gefunden",
  "Check class": "Klasse prüfen",
  "Edaptio": "Edaptio",
  "UMS": "UMS",
  "{count} more matching classes are hidden because UMS/Ludus is not describing them right now.": "{count} weitere Treffer sind ausgeblendet, weil UMS/Ludus sie derzeit nicht führt.",
  "Ends": "Endet",
  "Reading UMS/Ludus...": "UMS/Ludus wird gelesen...",
  "Matching students": "Übereinstimmende Teilnehmer",
  "in UMS/Ludus": "in UMS/Ludus",
  "This class already matches UMS/Ludus. Nothing to do.": "Die Klasse stimmt bereits mit UMS/Ludus überein. Nichts zu tun.",
  "In Edaptio, but not on the hold in UMS/Ludus": "In Edaptio, aber nicht im Kurs in UMS/Ludus",
  "These will be moved to dropped-out students. They keep their work and can be added back.": "Diese werden zu den abgemeldeten Teilnehmern verschoben. Ihre Arbeit bleibt erhalten und sie können wieder hinzugefügt werden.",
  "On the hold in UMS/Ludus, but not in Edaptio": "Im Kurs in UMS/Ludus, aber nicht in Edaptio",
  "These will be enrolled in the class.": "Diese werden in die Klasse eingeschrieben.",
  "Refresh from UMS/Ludus": "Erneut aus UMS/Ludus laden",
  "Update class": "Klasse aktualisieren",
  "Could not read UMS/Ludus right now. Try again shortly.": "UMS/Ludus konnte gerade nicht gelesen werden. Bitte in Kürze erneut versuchen.",
  "Could not update the class right now. Try again shortly.": "Die Klasse konnte gerade nicht aktualisiert werden. Bitte in Kürze erneut versuchen.",
  "From UMS/Ludus": "Aus UMS/Ludus",
  "From Moodle": "Aus Moodle",
  "Added manually": "Manuell hinzugefügt",
  "Added via invitation": "Per Einladung hinzugefügt",
  "Joined with a code": "Mit einem Code beigetreten",
  "Added automatically": "Automatisch hinzugefügt",
  "Unknown origin": "Unbekannte Herkunft",
  "Class updated": "Klasse aktualisiert",
  "moved to dropped-out students": "zu abgemeldeten Teilnehmern verschoben",
  "enrolled": "eingeschrieben",
  "Fixed user details": "Reparierte Benutzerdetails",
  "Student Administration ID": "Studentenverwaltungs-ID",
  "Student ID is required": "Studenten-ID ist erforderlich",
  "Student ID must be a valid number": "Studenten-ID muss eine gültige Nummer sein",
  "Student record has been successfully fixed": "Studentendatensatz wurde erfolgreich repariert",
  "Student not found in university system": "Student im Universitätssystem nicht gefunden",
  "An error occurred while fixing the student record": "Beim Reparieren des Studentendatensatzes ist ein Fehler aufgetreten",
  "This page is for fixing missing students who has purged when UMS created the new ID's without notifying us.": "Diese Seite dient zur Reparatur fehlender Studenten, die gelöscht wurden, als UMS neue IDs erstellt hat, ohne uns zu benachrichtigen.",
  "INPUT THE STUDENT ID FROM UMS HERE": "GEBEN SIE HIER DIE STUDENTEN-ID AUS UMS EIN",
  "SUCCESS: user fixed": "ERFOLG: Benutzer repariert",
  "ERROR: user not found": "FEHLER: Benutzer nicht gefunden",
  "The student is not in Edaptio currently.": "Der Student ist derzeit nicht in Edaptio.",
  "Users": "Benutzer",
  "Search for a user": "Nach einem Benutzer suchen",
  "Use the search field above to find users": "Verwenden Sie das Suchfeld oben, um Benutzer zu finden",
  "Merge users": "Benutzer zusammenführen",
  "Admin Users": "Administrator-Benutzer",
  "View Admin Users": "Administrator-Benutzer anzeigen",
  "User ID": "Benutzer-ID",
  "This user already exists": "Dieser Benutzer existiert bereits",
  "Add to institution": "Zur Institution hinzufügen",
  "already has an Edaptio account that is not attached to this institution. Add the existing user instead of creating a new one?":
      "hat bereits ein Edaptio-Konto, das nicht mit dieser Institution verknüpft ist. Möchten Sie den vorhandenen Benutzer hinzufügen, statt einen neuen zu erstellen?",
  "User added to the institution": "Benutzer zur Institution hinzugefügt",
  "User added. Send them a new password to let them log in":
      "Benutzer hinzugefügt. Senden Sie ein neues Passwort, damit die Person sich anmelden kann",
  "User not found": "Benutzer nicht gefunden",
  "User is already in this institution": "Der Benutzer gehört bereits zu dieser Institution",
  "View users by permission group": "Benutzer nach Berechtigungsgruppe anzeigen",
  "Select Permission Group": "Berechtigungsgruppe auswählen",
  "Choose a permission group...": "Wählen Sie eine Berechtigungsgruppe...",
  "Please select a permission group": "Bitte wählen Sie eine Berechtigungsgruppe",
  "Choose a permission group from the dropdown above to view its members": "Wählen Sie eine Berechtigungsgruppe aus dem obigen Dropdown-Menü, um ihre Mitglieder anzuzeigen",
  "Total members": "Gesamtzahl der Mitglieder",
  "No users found in this permission group": "Keine Benutzer in dieser Berechtigungsgruppe gefunden",
  "Move to Permission Group": "In Berechtigungsgruppe verschieben",
  "Inactive User": "Inaktiver Benutzer",
  "Permission group updated successfully": "Berechtigungsgruppe erfolgreich aktualisiert",
  "Failed to update permission group": "Berechtigungsgruppe konnte nicht aktualisiert werden",
  "Failed to load admin users": "Administrator-Benutzer konnten nicht geladen werden",
  "Failed to load permission groups": "Berechtigungsgruppen konnten nicht geladen werden",
  "Copy to other class": "Copy to other class",
  "Copying Group": "Copying Class",
  "Finalizing group copy...": "Finalizing class copy...",
  "Group copy completed successfully!": "Class copy completed successfully!",
  "Successfully copied": "Successfully copied",
  "Group copy completed with errors": "Class copy completed with errors",
  "courses failed": "courses failed",
  "View failed courses": "View failed courses",
  "Copying group settings, apps, and other elements...": "Copying class settings, apps, and other elements...",
  "courses completed": "courses completed",
  "Starting...": "Starting...",
  "Copying course": "Copying course",
  "of": "of",
  "Failed to copy group": "Failed to copy class",
  "Failed to send notification": "Benachrichtigung konnte nicht gesendet werden",
  "New course released": "Neuer Kurs veröffentlicht",
  "New lesson released": "Neue Lektion veröffentlicht",
  "Notify Students": "Schüler benachrichtigen",

  // Realtime event toasts (src/components/misc/dialogue.vue)
  "A student submitted an assignment": "Ein Schüler hat eine Aufgabe abgegeben",
  "New submission": "Neue Abgabe",
  "Feedback on your assignment is ready": "Feedback zu deiner Aufgabe liegt vor",
  "Feedback": "Feedback",
  "A student just took a quiz": "Ein Schüler hat gerade ein Quiz beantwortet",
  "Quiz attempt": "Quiz-Versuch",
  "You passed a quiz": "Du hast ein Quiz bestanden",
  "Your quiz was graded": "Dein Quiz wurde bewertet",
  "Quiz": "Quiz",
  "A new course is available": "Ein neuer Kurs ist verfügbar",
  "New course": "Neuer Kurs",
  "released a course in": "hat einen Kurs veröffentlicht in",
  "released a lesson in": "hat eine Lektion veröffentlicht in",
  "Send notification to all students in this group about this course release?": "Benachrichtigung über die Kursveröffentlichung an alle Schüler in dieser Gruppe senden?",
  "Send notification to all students in this group about this lesson release?": "Benachrichtigung über die Lektionsveröffentlichung an alle Schüler in dieser Gruppe senden?",
  "Students have been notified about the course release": "Die Schüler wurden über die Kursveröffentlichung benachrichtigt",
  "Students have been notified about the lesson release": "Die Schüler wurden über die Lektionsveröffentlichung benachrichtigt",
  "You do not have permission to send notifications for this course": "Sie haben keine Berechtigung, Benachrichtigungen für diesen Kurs zu senden",
  "You do not have permission to send notifications for this lesson": "Sie haben keine Berechtigung, Benachrichtigungen für diese Lektion zu senden",
  "Material not found": "Material nicht gefunden",
  "Archived Group Exclusions": "Archivierte Gruppenausschlüsse",
  "Active news": "Aktive Neuigkeiten",
  Inactive: "Inaktiv",
  Activate: "Aktivieren",
  Deactivate: "Deaktivieren",
  "News archive": "Archiv",
  "News activated": "Neuigkeit aktiviert",
  "News deactivated": "Neuigkeit deaktiviert",
  "Add to Exclusion List": "Zur Ausschlussliste hinzufügen",
  "Are you sure you want to remove this group from the exclusion list?": "Sind Sie sicher, dass Sie diese Gruppe von der Ausschlussliste entfernen möchten?",
  "Currently Excluded Groups": "Aktuell ausgeschlossene Gruppen",
  "Failed to exclude group": "Gruppe konnte nicht ausgeschlossen werden",
  "Failed to load excluded groups": "Ausgeschlossene Gruppen konnten nicht geladen werden",
  "Failed to remove group from exclusion list": "Gruppe konnte nicht von der Ausschlussliste entfernt werden",
  "Failed to search groups": "Gruppen konnten nicht gesucht werden",
  "Group ID": "Gruppen-ID",
  "Group is already in the exclusion list": "Gruppe ist bereits auf der Ausschlussliste",
  "Group is not in the exclusion list": "Gruppe ist nicht auf der Ausschlussliste",
  "Group successfully excluded": "Gruppe erfolgreich ausgeschlossen",
  "Group successfully removed from exclusion list": "Gruppe erfolgreich von der Ausschlussliste entfernt",
  "No excluded groups found": "Keine ausgeschlossenen Gruppen gefunden",
  "Remove from Exclusion List": "Von Ausschlussliste entfernen",
  "Search Groups to Exclude": "Gruppen zum Ausschließen suchen",
  "Select the language of the source": "Wählen Sie die Sprache der Quelle",
  "Select the language for the results": "Wählen Sie die Sprache für die Ergebnisse",
  "Please select the language you want the generated content in": "Bitte wählen Sie die Sprache, in der der generierte Inhalt erstellt werden soll",
  "Let's begin!": "Los geht's!",
  "Selected Group": "Ausgewählte Gruppe",
  "Selected user": "Ausgewählter Benutzer",
  "Select a group to view details": "Wählen Sie eine Gruppe aus, um Details anzuzeigen",
  "You do not have permission to perform this action": "Sie haben keine Berechtigung, diese Aktion auszuführen",
  "Require attachment": "Anhang erforderlich",
  "When enabled, students must attach a file. Text-only submissions will not be accepted.": "Wenn aktiviert, müssen Schüler eine Datei anhängen. Reine Texteinreichungen werden nicht akzeptiert.",
  "Attachment required": "Anhang erforderlich",
  "This file type is not allowed here": "Dieser Dateityp ist hier nicht erlaubt",
  "The file is empty (0 bytes) and cannot be uploaded. Save or export it again, then try again. If it is in OneDrive or iCloud, download it to your computer first.":
    "Die Datei ist leer (0 Bytes) und kann nicht hochgeladen werden. Speichern oder exportieren Sie sie erneut und versuchen Sie es dann noch einmal. Liegt sie in OneDrive oder iCloud, laden Sie sie zuerst auf Ihren Computer herunter.",
  "This assignment only accepts PDF files.": "Diese Abgabe akzeptiert nur PDF-Dateien.",
  "This assignment only accepts video files.": "Diese Abgabe akzeptiert nur Videodateien.",
  "This assignment only accepts PDF files. Please convert your file to PDF and try again.": "Diese Abgabe akzeptiert nur PDF-Dateien. Bitte konvertieren Sie Ihre Datei in PDF und versuchen Sie es erneut.",
  "You must attach your assignment file to this submission. Do not write your assignment in the text editor below.": "Sie müssen Ihre Aufgabendatei zu dieser Einreichung anhängen. Schreiben Sie Ihre Aufgabe nicht im Texteditor unten.",
  "Warning: Submissions without an attached file may be rejected by the teacher.": "Warnung: Einreichungen ohne angehängte Datei können vom Lehrer abgelehnt werden.",
  "You must attach your file - do not write in the text editor!": "Sie müssen Ihre Datei anhängen - schreiben Sie nicht im Texteditor!",
  "This assignment requires an attachment. Please attach your file before submitting.": "Diese Aufgabe erfordert einen Anhang. Bitte hängen Sie Ihre Datei vor dem Einreichen an.",
  Inaccessible: "Nicht zugänglich",
  Public: "Öffentlich",
  "This assignment is not accessible": "Diese Aufgabe ist nicht zugänglich",
  Visibility: "Sichtbarkeit",

  "Remove manual submission": "Manuelle Einreichung entfernen",
  "Are you sure you want to delete this manual submission?": "Sind Sie sicher, dass Sie diese manuelle Einreichung löschen möchten?",
  "This will also delete the associated feedback.": "Dies wird auch das zugehörige Feedback löschen.",
  "Yes, delete this submission": "Ja, diese Einreichung löschen",
  "Manual submission removed": "Manuelle Einreichung entfernt",
  none: "keine",
  "No past consultations": "Keine vergangenen Konsultationen",
  "Consultation created": "Konsultation erstellt",
  "Consultation updated": "Konsultation aktualisiert",
  "Consultation deleted": "Konsultation gelöscht",
  "Failed to save consultation": "Konsultation konnte nicht gespeichert werden",
  "Failed to join video call": "Videoanruf konnte nicht beigetreten werden",
  "Failed to load consultation": "Konsultation konnte nicht geladen werden",
  "Failed to remove consultation": "Konsultation konnte nicht entfernt werden",
  "Camera not available. You can still join with audio.": "Kamera nicht verfügbar. Sie können trotzdem mit Audio teilnehmen.",
  "No video room available for this consultation": "Kein Videoraum für diese Konsultation verfügbar",
  "Video call error": "Videoanruf-Fehler",

  // --- KI-Assistent (agent.edaptio.com) ---
  "AI Assistant": "KI-Assistent",
  "agent.hide.label": "Olly bis zum Neuladen der Seite ausblenden",
  "agent.hide.permanent_hint": "Ganz ausschalten können Sie Olly in Ihrem Profil",
  "Show the Olly assistant on my screen": "Olly-Assistent auf meinem Bildschirm anzeigen",
  "transcription.user_setting.title": "Aufnahmen im Korrekturmodul",
  "Write out what I say in my recordings": "Meine Aufnahmen als Text ausschreiben",
  "transcription.user_setting.hint": "Wenn dies ausgeschaltet ist, steht unter Ihren Sprach- und Bildschirmaufnahmen kein Text — die Lernenden müssen die Aufnahme ansehen oder anhören. Das gilt für alle Aufnahmen, die Sie selbst machen. Eine Lehrkraft kann es auch für einen ganzen Kurs ausschalten.",
  "transcription.group_setting.title": "Aufnahmen im Korrekturmodul",
  "transcription.group_setting.description": "Legen Sie fest, ob Sprach- und Bildschirmaufnahmen in diesem Kurs als Text ausgeschrieben werden. Wenn dies ausgeschaltet ist, steht unter der Aufnahme kein Text — weder im Kommentarbereich noch im korrigierten PDF. Das gilt für alle Lehrkräfte des Kurses.",
  "Write out speech in recordings": "Sprache als Text ausschreiben",
  "olly.user_setting.hint": "Wenn Sie dies ausschalten, wird Olly überall in Edaptio für Sie ausgeblendet. Ihre Schule oder die Lehrkraft eines Kurses kann Olly ebenfalls ausschalten — das können Sie nicht überschreiben.",
  "Show small confirmations in the corner of the screen": "Kleine Bestätigungen in der Bildschirmecke anzeigen",
  "ui_toasts.user_setting.hint": "Das sind die kleinen grünen Felder unten links, z. B. \"Datum gespeichert\". Fehlermeldungen werden immer angezeigt.",
  "olly.group_setting.description": "Legen Sie fest, ob Olly in diesem Kurs verwendet werden darf. Wenn Sie es für Lernende ausschalten, können diese Olly im Kurs für nichts mehr nutzen — auch nicht von ihrem eigenen Bildschirm aus. Die beiden Schalter sind voneinander unabhängig.",
  "Allow Olly for students": "Olly für Lernende erlauben",
  "Allow Olly for teachers": "Olly für Lehrkräfte erlauben",
  "annotator.mismatch.embedpdf_committed": "Diese Abgabe wurde in EmbedPDF korrigiert. Diese Markierungen erscheinen nicht in Kami.",
  "annotator.mismatch.kami_committed": "Diese Abgabe wurde in Kami korrigiert. Diese Markierungen erscheinen nicht in EmbedPDF.",
  "Connecting...": "Verbindung wird hergestellt...",
  "Minimize": "Minimieren",
  "Ask the assistant anything about your classes, assignments, or content.": "Fragen Sie den Assistenten zu Ihren Klassen, Aufgaben oder Inhalten.",
  "Thinking...": "Denkt nach...",
  "Ask the assistant...": "Assistent fragen...",
  "Send": "Senden",
  "New conversation": "Neue Unterhaltung",
  "Conversations": "Unterhaltungen",
  "No previous conversations": "Keine früheren Unterhaltungen",
  "Untitled chat": "Ohne Titel",
  "Archive": "Archivieren",
  "Delete this conversation?": "Diese Unterhaltung löschen?",
  "Loading conversation...": "Unterhaltung wird geladen...",

  // --- AI Agent empty-state suggestion chips ---
  "agent.suggestion.student.1": "Was muss ich abgeben?",
  "agent.suggestion.student.2": "Gibt es Neuigkeiten in meiner Klasse?",
  "agent.suggestion.student.3": "Wie stehe ich in meinen Fächern?",
  "agent.suggestion.student.4": "Erkläre mir meine nächste Aufgabe",
  "agent.suggestion.teacher.1": "Wie läuft es in meiner Klasse?",
  "agent.suggestion.teacher.2": "Welche Schüler sind im Rückstand?",
  "agent.suggestion.teacher.3": "Erstelle ein Quiz für diese Lektion",
  "agent.suggestion.teacher.4": "Schreibe einen Newsbeitrag an die Klasse",

  // Teaser bubble next to the closed Olly icon (students only)
  "Dismiss": "Ausblenden",
  "agent.teaser.generic": "Hilfe von Olly bekommen",
  "agent.teaser.assignment": "Hilfe bei dieser Aufgabe?",
  "agent.teaser.assignment.prompt": "Kannst du mir diese Aufgabe erklären und mir beim Einstieg helfen?",
  "Reconnecting...": "Verbinde erneut...",
  "Connection lost. Reload the page to try again.": "Verbindung verloren. Seite neu laden, um es erneut zu versuchen.",
  "agent.header.subtitle": "Frag mich etwas",
  "agent.empty.greeting.named": "Hallo {name} 👋",
  "agent.empty.greeting.generic": "Hallo 👋",

  // --- AI Agent tool labels ---
  "tool.find_upcoming_assignments.running": "Anstehende Aufgaben werden gesucht…",
  "tool.find_upcoming_assignments.done": "Anstehende Aufgaben geladen",
  "tool.lookup_assignment.running": "Aufgabe wird geladen…",
  "tool.lookup_assignment.done": "Aufgabe geladen",
  "tool.lookup_my_handin.running": "Deine Abgabe wird geladen…",
  "tool.lookup_my_handin.done": "Abgabe geladen",
  "tool.lookup_learning_element.running": "Lernelement wird geladen…",
  "tool.lookup_learning_element.done": "Lernelement geladen",
  "tool.list_my_classes.running": "Deine Klassen werden geladen…",
  "tool.list_my_classes.done": "Klassen geladen",
  "tool.lookup_group.running": "Klasse wird geladen…",
  "tool.lookup_group.done": "Klasse geladen",
  "tool.list_members.running": "Mitglieder werden geladen…",
  "tool.list_members.done": "Mitglieder geladen",
  "tool.list_group_information.running": "Klasseninfo wird geladen…",
  "tool.list_group_information.done": "Klasseninfo geladen",
  "tool.list_news.running": "Neuigkeiten werden geladen…",
  "tool.list_news.done": "Neuigkeiten geladen",
  "tool.get_my_progress.running": "Dein Fortschritt wird geladen…",
  "tool.get_my_progress.done": "Fortschritt geladen",
  "tool.list_missing_feedback.running": "Fehlendes Feedback wird geprüft…",
  "tool.list_missing_feedback.done": "Fehlendes Feedback geladen",
  "tool.list_notifications.running": "Benachrichtigungen werden geladen…",
  "tool.list_notifications.done": "Benachrichtigungen geladen",
  "tool.create_assignment.running": "Aufgabe wird erstellt…",
  "tool.create_assignment.done": "Aufgabe erstellt",
  "tool.update_assignment.running": "Aufgabe wird aktualisiert…",
  "tool.update_assignment.done": "Aufgabe aktualisiert",
  "tool.create_quiz.running": "Quiz wird erstellt…",
  "tool.create_quiz.done": "Quiz erstellt",
  "tool.create_quiz_question.running": "Frage wird hinzugefügt…",
  "tool.create_quiz_question.done": "Frage hinzugefügt",
  "tool.create_flashcard_deck.running": "Lernkartenset wird erstellt…",
  "tool.create_flashcard_deck.done": "Lernkartenset erstellt",
  "tool.create_flashcard.running": "Lernkarte wird erstellt…",
  "tool.create_flashcard.done": "Lernkarte erstellt",
  "tool.create_text_element.running": "Textelement wird erstellt…",
  "tool.create_text_element.done": "Textelement erstellt",
  "tool.create_lesson.running": "Lektion wird erstellt…",
  "tool.create_lesson.done": "Lektion erstellt",
  "tool.create_course.running": "Kurs wird erstellt…",
  "tool.create_course.done": "Kurs erstellt",
  "tool.create_news.running": "Nachricht wird gepostet…",
  "tool.create_news.done": "Nachricht gepostet",
  "tool.create_group_information.running": "Klasseninfo wird erstellt…",
  "tool.create_group_information.done": "Klasseninfo erstellt",
  "tool.attach_element_to_lesson.running": "Wird an Lektion angehängt…",
  "tool.attach_element_to_lesson.done": "An Lektion angehängt",
  "tool.move_learning_element.running": "Elemente werden verschoben…",
  "tool.move_learning_element.done": "Elemente verschoben",
  "tool.hide_learning_element.running": "Sichtbarkeit wird geändert…",
  "tool.hide_learning_element.done": "Sichtbarkeit geändert",
  "tool.move_lesson.running": "Lektion wird verschoben…",
  "tool.move_lesson.done": "Lektion verschoben",
  "tool.reorder_courses.running": "Kurse werden sortiert…",
  "tool.reorder_courses.done": "Kurse sortiert",
  "tool.update_course.running": "Kurs wird aktualisiert…",
  "tool.update_course.done": "Kurs aktualisiert",
  "tool.update_lesson.running": "Lektion wird aktualisiert…",
  "tool.update_lesson.done": "Lektion aktualisiert",
  "tool.lookup_lesson.running": "Lektion wird gelesen…",
  "tool.lookup_lesson.done": "Lektion gelesen",
  "tool.lookup_quiz.running": "Quiz wird gelesen…",
  "tool.lookup_quiz.done": "Quiz gelesen",
  "tool.update_quiz.running": "Quiz wird aktualisiert…",
  "tool.update_quiz.done": "Quiz aktualisiert",
  "tool.update_quiz_question.running": "Frage wird aktualisiert…",
  "tool.update_quiz_question.done": "Frage aktualisiert",
  "tool.delete_quiz_question.running": "Frage wird entfernt…",
  "tool.delete_quiz_question.done": "Frage entfernt",
  "tool.delete_learning_element.running": "Element wird entfernt…",
  "tool.delete_learning_element.done": "Element entfernt",
  "tool.grade_handin.running": "Feedback wird gegeben…",
  "tool.grade_handin.done": "Feedback gegeben",
  "tool.release_feedback.running": "Feedback wird freigegeben…",
  "tool.release_feedback.done": "Feedback freigegeben",
  "tool.class_overview.running": "Klassenübersicht wird erstellt…",
  "tool.class_overview.done": "Klassenübersicht geladen",
  "tool.list_students_behind.running": "Rückständige Schüler werden geprüft…",
  "tool.list_students_behind.done": "Rückständige Schüler geladen",
  "tool.send_message.running": "Nachricht wird gesendet…",
  "tool.send_message.done": "Nachricht gesendet",
  "tool.create_timeline.running": "Zeitleiste wird erstellt…",
  "tool.create_timeline.done": "Zeitleiste erstellt",
  "tool.lookup_timeline.running": "Zeitleiste wird geladen…",
  "tool.lookup_timeline.done": "Zeitleiste geladen",
  "tool.update_timeline.running": "Zeitleiste wird aktualisiert…",
  "tool.update_timeline.done": "Zeitleiste aktualisiert",
  "tool.update_text_element.running": "Textelement wird aktualisiert…",
  "tool.update_text_element.done": "Textelement aktualisiert",
  "tool.create_external_link.running": "Link wird erstellt…",
  "tool.create_external_link.done": "Link erstellt",
  "tool.update_external_link.running": "Link wird aktualisiert…",
  "tool.update_external_link.done": "Link aktualisiert",
  "tool.create_media_embed.running": "Video wird eingebettet…",
  "tool.create_media_embed.done": "Video eingebettet",
  "tool.update_media.running": "Medium wird aktualisiert…",
  "tool.update_media.done": "Medium aktualisiert",
  "tool.create_questionnaire.running": "Fragebogen wird erstellt…",
  "tool.create_questionnaire.done": "Fragebogen erstellt",
  "tool.lookup_questionnaire.running": "Fragebogen wird geladen…",
  "tool.lookup_questionnaire.done": "Fragebogen geladen",
  "tool.update_questionnaire.running": "Fragebogen wird aktualisiert…",
  "tool.update_questionnaire.done": "Fragebogen aktualisiert",
  "tool.lookup_flashcard_deck.running": "Karteikartensatz wird geladen…",
  "tool.lookup_flashcard_deck.done": "Karteikartensatz geladen",
  "tool.update_flashcard_deck.running": "Karteikartensatz wird aktualisiert…",
  "tool.update_flashcard_deck.done": "Karteikartensatz aktualisiert",
  "tool.create_board.running": "Board wird erstellt…",
  "tool.create_board.done": "Board erstellt",
  "tool.add_board_note.running": "Notiz wird hinzugefügt…",
  "tool.add_board_note.done": "Notiz hinzugefügt",
  "tool.update_board.running": "Board wird aktualisiert…",
  "tool.update_board.done": "Board aktualisiert",
  // EmbedPDF rich annotations (Kami replacement V1, 2026-05-06)
  "Annotations": "Annotationen",
  "Could not start recording": "Aufnahme konnte nicht gestartet werden",
  "The recording came out empty. Please try again.": "Die Aufnahme war leer. Bitte versuchen Sie es erneut.",
  "Equation": "Gleichung",
  "Microphone is not available in this browser":
    "Mikrofon ist in diesem Browser nicht verfügbar",
  "No rich annotations yet": "Noch keine Rich-Annotationen",
  "Re-record": "Erneut aufnehmen",
  "Read aloud": "Vorlesen",
  "Record": "Aufnehmen",
  "Rich comment": "Rich-Kommentar",
  "Interactive content": "Interaktiver Inhalt",
  "Add interactive content": "Interaktiven Inhalt hinzufügen",
  "Edit interactive content": "Interaktiven Inhalt bearbeiten",
  "Save interactive content": "Interaktiven Inhalt speichern",
  "Upload package": "Paket hochladen",
  "Replace package": "Paket ersetzen",
  "Processing package\u2026": "Paket wird verarbeitet…",
  "Upload a zip of a static HTML site (index.html at the top level), a single HTML file, or a .h5p package": "Laden Sie eine ZIP-Datei einer statischen HTML-Seite (index.html auf oberster Ebene), eine einzelne HTML-Datei oder ein .h5p-Paket hoch",
  "The file could not be read as a zip archive.": "Die Datei konnte nicht als ZIP-Archiv gelesen werden.",
  "The package contains too many files (max 2000).": "Das Paket enthält zu viele Dateien (max. 2000).",
  "The package is too large when unpacked (max 500 MB).": "Das Paket ist entpackt zu groß (max. 500 MB).",
  "The zip must contain an index.html at its top level (or be a valid .h5p package).": "Die ZIP-Datei muss eine index.html auf oberster Ebene enthalten (oder ein gültiges .h5p-Paket sein).",
  "This .h5p file does not include its libraries. Export the .h5p with libraries included (e.g. via Lumi) and try again.": "Diese .h5p-Datei enthält ihre Bibliotheken nicht. Exportieren Sie die .h5p-Datei mit Bibliotheken (z. B. über Lumi) und versuchen Sie es erneut.",
  "The package contains an unsafe file path and was rejected.": "Das Paket enthält einen unsicheren Dateipfad und wurde abgelehnt.",
  "Save annotation": "Annotation speichern",
  "Stop failed": "Stoppen fehlgeschlagen",
  "Stop": "Stopp",
  "Transcribing…": "Wird transkribiert…",
  "Uploading…": "Wird hochgeladen…",
  "Voice note": "Sprachnotiz",
  "You need {percentage}% correct to pass": "Sie benötigen {percentage}% richtige Antworten zum Bestehen",
  "Show the pass percentage to learners": "Bestehensgrenze für Lernende anzeigen",
  "Follow the class setting": "Einstellung des Kurses übernehmen",
  "Always show": "Immer anzeigen",
  "Always hide": "Immer ausblenden",
  "Quizzes": "Quiz",
  "Learners see the pass requirement on the front page of every quiz on this class, before they start. A single quiz can override this in its own advanced settings.": "Lernende sehen die Bestehensgrenze auf der Startseite jedes Quiz in diesem Kurs, bevor sie beginnen. Ein einzelnes Quiz kann dies in seinen erweiterten Einstellungen überschreiben.",
  "Learners see the requirement on the quiz front page before they start. The class setting decides unless you override it here.": "Lernende sehen die Anforderung auf der Startseite des Quiz, bevor sie beginnen. Es gilt die Einstellung des Kurses, sofern Sie sie hier nicht überschreiben.",
  "This mark already has a recording": "Diese Markierung hat bereits eine Aufnahme",
  "Video comment": "Videokommentar",
  "Screen recording": "Bildschirmaufnahme",
  "Watch video comment": "Videokommentar ansehen",
  "Watch screen recording": "Bildschirmaufnahme ansehen",
  "Click on the PDF to place the video comment": "Klicken Sie auf das PDF, um den Videokommentar zu platzieren",
  "Click on the PDF to place the screen recording": "Klicken Sie auf das PDF, um die Bildschirmaufnahme zu platzieren",
  "Formula": "Formel",
  "Place formula": "Formel einfügen",
  "Update formula": "Formel aktualisieren",
  "Insert formula": "Formel einfügen",
  "Click on the PDF to place the formula": "Klicken Sie auf das PDF, um die Formel zu platzieren",
  "The formula could not be rendered. Check it and try again.": "Die Formel konnte nicht dargestellt werden. Bitte prüfen und erneut versuchen.",
  "Structure": "Aufbau",
  "Relations": "Relationen",
  "Operators": "Rechenzeichen",
  "Greek letters": "Griechische Buchstaben",
  "Functions": "Funktionen",
  "Fraction": "Bruch",
  "Square root": "Quadratwurzel",
  "Nth root": "N-te Wurzel",
  "Power": "Potenz",
  "Subscript": "Tiefgestellt",
  "Parentheses": "Klammern",
  "Absolute value": "Absolutbetrag",
  "Less than or equal to": "Kleiner oder gleich",
  "Greater than or equal to": "Größer oder gleich",
  "Not equal to": "Ungleich",
  "Approximately equal to": "Ungefähr gleich",
  "Plus-minus": "Plus-Minus",
  "Implies": "Impliziert",
  "Multiplication dot": "Multiplikationspunkt",
  "Times": "Mal",
  "Divided by": "Geteilt durch",
  "Sum": "Summe",
  "Integral": "Integral",
  "Limit": "Grenzwert",
  "Infinity": "Unendlich",
  "Pi": "Pi",
  "Alpha": "Alpha",
  "Beta": "Beta",
  "Theta": "Theta",
  "Delta": "Delta",
  "Degree": "Grad",
  "Sine": "Sinus",
  "Cosine": "Kosinus",
  "Tangent": "Tangens",
  "Logarithm": "Logarithmus",
  "Natural logarithm": "Natürlicher Logarithmus",
  "Open the comments panel to see your recordings": "Öffnen Sie das Kommentarfeld, um Ihre Aufnahmen zu sehen",
  "Recordings": "Aufnahmen",
  "Go to page": "Zur Seite",
  "Camera": "Kamera",
  "Recording": "Aufnahme läuft",
  "Screen recording is not available in this browser. On iPad, record a video comment instead.": "Bildschirmaufnahme ist in diesem Browser nicht verfügbar. Nehmen Sie auf dem iPad stattdessen einen Videokommentar auf.",
  "This browser records in a format some phones cannot play. Chrome or Safari gives the best result.": "Dieser Browser nimmt in einem Format auf, das manche Telefone nicht abspielen können. Chrome oder Safari liefert das beste Ergebnis.",
  "Share only the window or tab you want to record — avoid sharing your whole screen.": "Teilen Sie nur das Fenster oder den Tab, den Sie aufnehmen möchten — vermeiden Sie es, den gesamten Bildschirm zu teilen.",
  "Uploaded": "Hochgeladen",
  "Start recording": "Aufnahme starten",
  "Eraser": "Radiergummi",
  "Comment on selection": "Auswahl kommentieren",
  "Comment": "Kommentar",
  "Add comment": "Kommentar hinzufügen…",
  "Comments in the margin": "Kommentare am Rand",
  "Comments in the margin: on": "Kommentare am Rand: ein",
  "Comments in the margin: off": "Kommentare am Rand: aus",
  "Click on the PDF to place the voice note":
    "Klicken Sie auf das PDF, um die Sprachnotiz zu platzieren",
  "Open the comments panel to see voice notes":
    "Öffnen Sie das Kommentarpanel, um Sprachnotizen zu sehen",
  "Microphone": "Mikrofon",
  "Microphone permission denied": "Mikrofonzugriff verweigert",
  "No microphone detected": "Kein Mikrofon erkannt",
  "Default microphone": "Standardmikrofon",
  "We can hear you": "Wir können Sie hören",
  "Speak to test your microphone": "Sprechen Sie, um Ihr Mikrofon zu testen",
  "Allow microphone access to record":
    "Erlauben Sie Mikrofonzugriff, um aufzunehmen",
  "Could not export annotated PDF":
    "Annotiertes PDF konnte nicht exportiert werden",
  "Could not attach the corrections to the feedback":
    "Die Korrekturen konnten nicht an das Feedback angehängt werden",
  "Could not open the document":
    "Das Dokument konnte nicht geöffnet werden",
  "Could not download the document":
    "Das Dokument konnte nicht heruntergeladen werden",
  "Some annotations could not be saved. Please check your connection and try again.":
    "Einige Anmerkungen konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "You have unsaved annotation changes. Close anyway?":
    "Sie haben ungespeicherte Anmerkungsänderungen. Trotzdem schließen?",
  "Close anyway": "Trotzdem schließen",
  "(continued)": "(Fortsetzung)",
  "Listen to voice note": "Sprachnotiz anhören",
  "Select text in the PDF first": "Markieren Sie zuerst Text im PDF",
  "Maximum recording length reached": "Maximale Aufnahmelänge erreicht",
  "External login failed. Please try again.": "Externe Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "Download as PDF": "Als PDF herunterladen",
  "Preparing…": "Wird vorbereitet…",
  "Could not open the document for editing":
    "Dokument konnte nicht zur Bearbeitung geöffnet werden",
  "Add question title": "Fragetitel hinzufügen",
  "Provide general feedback about the question":
    "Geben Sie allgemeines Feedback zur Frage",
  "Could not send an invitation to: {emails}":
    "Einladung konnte nicht gesendet werden an: {emails}",
  "Could not send the invitations. Please try again.":
    "Die Einladungen konnten nicht gesendet werden. Bitte versuchen Sie es erneut.",
  "Email sender name": "Absendername für E-Mails",
  "Shown as the sender of emails. Leave empty to use Edaptio.":
    "Wird als Absender von E-Mails angezeigt. Leer lassen, um Edaptio zu verwenden.",
  "Sender name": "Absendername",
  "Email reply-to address": "Antwortadresse für E-Mails",
  "Replies to emails are sent here. Leave empty to use Edaptio.":
    "Antworten auf E-Mails werden hierhin gesendet. Leer lassen, um Edaptio zu verwenden.",
  "Your school creates your Edaptio account for you":
    "Deine Schule erstellt dein Edaptio-Konto für dich. Warte, bis es bereit ist, oder wende dich an deine Schule, wenn du dich nicht anmelden kannst.",
  "This Microsoft account belongs to your school and can only be connected to your school account":
    "Dieses Microsoft-Konto gehört deiner Schule und kann nur mit deinem Schulkonto verbunden werden. Melde dich mit deinem Schulkonto an und versuche es erneut.",
    "Download summary": "Zusammenfassung herunterladen",
    "Download all answers": "Alle Antworten herunterladen",
    "Question number": "Fragenummer",
    "Question text": "Fragetext",
    "Number of answers": "Anzahl der Antworten",
    "Share of answers": "Anteil der Antworten",
    "Response": "Antwort",
    "Started": "Gestartet",
    "Summary": "Zusammenfassung",
    "All answers": "Alle Antworten",
    "Evaluations": "Evaluierungen",
    "Overview": "Übersicht",
    "Group": "Klasse",
    "Questions": "Fragen",
    "Last answered": "Zuletzt beantwortet",
    "Evaluation": "Evaluierung",
    "Evaluation ID": "Evaluierungs-ID",
    "Sheet": "Blatt",
    "Responses": "Antworten",
    "Every evaluation on the school's classes. Select the ones you need and download them as one Excel file, each evaluation on its own sheet.": "Alle Evaluierungen in den Klassen der Schule. Wähle die gewünschten aus und lade sie als eine Excel-Datei herunter, jede Evaluierung auf einem eigenen Blatt.",
    "Search by title or class": "Nach Titel oder Klasse suchen",
    "Only evaluations with answers": "Nur Evaluierungen mit Antworten",
    "Download {count} evaluations as Excel": "{count} Evaluierungen als Excel herunterladen",
    "Fetching answers… {done} of {total}": "Antworten werden geladen… {done} von {total}",
    "No evaluations found": "Keine Evaluierungen gefunden",
    "Could not load the evaluations. Please try again.": "Die Evaluierungen konnten nicht geladen werden. Bitte versuche es erneut.",
    "Could not download the evaluations. Please try again.": "Die Evaluierungen konnten nicht heruntergeladen werden. Bitte versuche es erneut.",
  "Remove unenrolled students from classes": "Abgemeldete Teilnehmer aus Klassen entfernen",
  "Students UMS/Ludus no longer has on a class are moved to dropped-out students on every sync.": "Teilnehmer, die UMS/Ludus nicht mehr in einer Klasse führt, werden bei jeder Synchronisierung zu abgemeldeten Teilnehmern verschoben.",
  "Synchronise with UMS/Ludus": "Mit UMS/Ludus synchronisieren",
  "Runs the same synchronisation as the nightly one: new and moved students are enrolled, and — if the switch above is on — unenrolled students are moved to dropped-out students.": "Führt dieselbe Synchronisierung aus wie die nächtliche: neue und verschobene Teilnehmer werden eingeschrieben und — wenn der Schalter oben aktiv ist — abgemeldete Teilnehmer zu abgemeldeten verschoben.",
  "Last synchronisation": "Letzte Synchronisierung",
  "Last manual synchronisation": "Letzte manuelle Synchronisierung",
  "{count} students moved to dropped-out students": "{count} Teilnehmer zu abgemeldeten verschoben",
  "A synchronisation starts within five minutes and takes up to 15. It runs in the background — you can leave this page.": "Eine Synchronisierung startet innerhalb von fünf Minuten und dauert bis zu 15. Sie läuft im Hintergrund — Sie können die Seite verlassen.",
  "Synchronise now": "Jetzt synchronisieren",
  "Synchronising...": "Synchronisiert...",
  "Synchronisation queued": "Synchronisierung eingereiht",
  "A synchronisation is already queued or running": "Eine Synchronisierung ist bereits eingereiht oder läuft",
  "Could not start the synchronisation right now. Try again shortly.": "Die Synchronisierung konnte gerade nicht gestartet werden. Bitte gleich erneut versuchen.",
  "Queued": "In der Warteschlange",
  "Running": "Läuft",
  "Completed": "Abgeschlossen",
  "Failed": "Fehlgeschlagen",
  "Dropped out earlier and added back": "Zuvor abgemeldet und wieder hinzugefügt",
  "This class is filled automatically from several holds, so it cannot be compared with one hold in UMS/Ludus.": "Diese Klasse wird automatisch aus mehreren Klassen befüllt und kann daher nicht mit einer Klasse in UMS/Ludus verglichen werden.",
  "Select messages": "Nachrichten auswählen",
  "Select conversations": "Unterhaltungen auswählen",
  "Cancel selection": "Auswahl abbrechen",
  "{count} selected": "{count} ausgewählt",
  "Select all": "Alle auswählen",
  "Deselect all": "Auswahl aufheben",
  // Split hold: students assigned to one of the hold's teachers
  "No students match your filters.": "Keine Schüler entsprechen deinen Filtern.",
  "All students": "Alle Schüler",
  "Not assigned": "Nicht zugewiesen",
  "No teacher": "Keine Lehrkraft",
  "Assign selected to": "Ausgewählte zuweisen an",
  "Students assigned": "Schüler zugewiesen",
  "Only my students": "Nur meine Schüler",
  "{n} selected": "{n} ausgewählt",
  "You can only delete messages you have sent yourself": "Du kannst nur Nachrichten löschen, die du selbst gesendet hast",
  "Do you want to delete {count} messages for all members?": "Möchtest du {count} Nachrichten für alle Teilnehmer löschen?",
  "{count} messages could not be deleted": "{count} Nachrichten konnten nicht gelöscht werden",
  "The messages were succesfully deleted": "Die Nachrichten wurden gelöscht",
  "Do you want to delete {count} conversations? They will only be removed for you.": "Möchtest du {count} Unterhaltungen löschen? Sie werden nur für dich entfernt.",
  "{count} conversations could not be deleted": "{count} Unterhaltungen konnten nicht gelöscht werden",
  "The conversations were succesfully deleted": "Die Unterhaltungen wurden gelöscht",
  "Do you want to archive {count} conversations?": "Möchtest du {count} Unterhaltungen archivieren?",
  "{count} conversations could not be archived": "{count} Unterhaltungen konnten nicht archiviert werden",
  "Archived": "Archiviert",
  "Institution": "Institution",
  "Institution name": "Institutionsname",
  "Active users": "Aktive Benutzer",
  "Total": "Gesamt",
  "Group name": "Kursname",
  "No results found": "Keine Ergebnisse gefunden",

  // Role-editor permission labels. de_DE had no permissions.* block at all, so
  // the German editor rendered raw snake_case names. These are the 13 the
  // catalogue is being consolidated to; `teacher` and the 11 edit_module_*
  // names it replaces are added when that lands.
  "permissions.teacher": "Lehrkraftrechte: Inhalte in eigenen Kursen anlegen und bearbeiten",
  "permissions.admin_groups_classes": "Kurse und Klassen der Institution verwalten",
  "permissions.view_groups_classes":
    "Alle Kurse und den Lernfortschritt einsehen, ohne etwas ändern zu können",
  "permissions.admin_institution_settings": "Allgemeine Einstellungen der Institution verwalten",
  "permissions.admin_institution_news": "Neuigkeiten der Institution verwalten",
  "permissions.admin_permissions": "Berechtigungen der Institution verwalten",
  "permissions.admin_moodle_administration": "MOODLE für die Institution administrieren",
  "permissions.admin_sign_in_as_other": "Als anderer Benutzer anmelden",
  "permissions.admin_stats": "Zugriff auf die Statistiken der Institution",
  "permissions.admin_ums": "Die UMS/Ludus-Synchronisation der Institution administrieren",
  "permissions.can_view_teacher_activity": "Aktivität der Lehrkräfte einsehen",
  "permissions.manage_client": "Kunden- und Abrechnungsdaten verwalten",
  "permissions.users_group_create_user_directly": "Benutzer direkt in einem Kurs anlegen",
  "Do you want to delete {count} selected files and folders?": "Möchtest du {count} ausgewählte Dateien und Ordner löschen?",
  "{count} files could not be deleted": "{count} Dateien konnten nicht gelöscht werden",
  "The files were deleted": "Die Dateien wurden gelöscht",
  "Show": "Anzeigen",
  "All": "Alle",
  "Showing": "Angezeigt",
  "Notes": "Notizen",
  "Write a note": "Notiz schreiben",
  "Add note": "Notiz hinzufügen",
  "No notes yet": "Noch keine Notizen",
  "General note": "Allgemeine Notiz",
  "Imported": "Importiert",
  "edited": "bearbeitet",
  "Delete this note?": "Diese Notiz löschen?",
  "See all notes": "Alle Notizen anzeigen",
  "Delete": "Löschen",
  "Edit": "Bearbeiten",
  "General": "Allgemein",
  "Save": "Speichern",
  "Notes about students": "Notizen zu Lernenden",
  "This file type cannot be uploaded. Save it as PDF or Word and try again.": "Dieser Dateityp kann nicht hochgeladen werden. Speichere die Datei als PDF oder Word und versuche es erneut.",
  "The upload lost its connection. Check your internet connection and try again.": "Beim Hochladen ist die Verbindung abgebrochen. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
  "This question could not be checked with its numbers, so it has new ones. Please answer it again.": "Diese Frage konnte mit ihren Zahlen nicht ausgewertet werden und hat deshalb neue bekommen. Bitte beantworte sie noch einmal.",
  "Your answer could not be checked right now. Please try again in a moment.": "Deine Antwort konnte gerade nicht ausgewertet werden. Bitte versuche es gleich noch einmal.",
  "Your answer could not be saved. Please try again.": "Deine Antwort konnte nicht gespeichert werden. Bitte versuche es noch einmal.",
  "Use notes about students": "Notizen zu Lernenden verwenden",
  "Teachers and administrators can keep notes about students, per class or general.": "Lehrkräfte und Administratoren können Notizen zu Lernenden führen, pro Klasse oder allgemein.",
  "Students can see notes about themselves": "Lernende können Notizen über sich selbst sehen",
  "Students see the notes about themselves, read-only, on the class member list.": "Lernende sehen die Notizen über sich in der Mitgliederliste der Klasse, ohne sie ändern zu können.",
  "Teachers can see general notes": "Lehrkräfte können allgemeine Notizen sehen",
  "Teachers see the general notes administrators write about the students they teach.": "Lehrkräfte sehen die allgemeinen Notizen der Verwaltung zu ihren Lernenden.",
  "Teachers can see other classes' notes": "Lehrkräfte können Notizen anderer Klassen sehen",
  "Teachers see notes from the student's other classes, not just their own classes.": "Lehrkräfte sehen auch Notizen aus den anderen Klassen der Lernenden, nicht nur aus ihren eigenen.",
  "The student can also see this note.": "Die/der Lernende kann diese Notiz auch sehen.",
  "Only teachers and administrators can see this note.": "Nur Lehrkräfte und Administratoren können diese Notiz sehen.",
  "This class isn't open yet": "Diese Klasse ist noch nicht geöffnet",
  "Your teacher has not opened anything for the class yet. Check back later.": "Deine Lehrkraft hat für die Klasse noch nichts freigegeben. Schau später noch einmal vorbei.",
  "The copy is taking longer than expected. It may still finish, so check the class in a few minutes before you copy again.": "Das Kopieren dauert länger als erwartet. Es kann trotzdem noch fertig werden, also sieh in ein paar Minuten in der Klasse nach, bevor du erneut kopierst.",
  "The copy failed. Please try again.": "Das Kopieren ist fehlgeschlagen. Bitte versuche es erneut.",
  "A download of the submissions is already in progress. Wait for it to finish.": "Die Abgaben werden bereits heruntergeladen. Warte, bis dieser Download abgeschlossen ist.",
  "Read-only access": "Lesezugriff",
  "People with read-only access see the hold's courses, lessons, assignments, files and news, as a student would. They cannot hand in, write or comment, and they do not see the members or anyone's work.": "Personen mit Lesezugriff sehen die Kurse, Lektionen, Aufgaben, Dateien und Neuigkeiten der Klasse so, wie ein Schüler sie sieht. Sie können nichts abgeben, schreiben oder kommentieren und sehen weder die Mitglieder noch die Arbeiten anderer.",
  "Access until (optional)": "Zugriff bis einschließlich (optional)",
  "Give read-only access": "Lesezugriff geben",
  "Nobody has read-only access to this hold.": "Niemand hat Lesezugriff auf diese Klasse.",
  "Access ended {date}": "Zugriff endete am {date}",
  "Access until {date}": "Zugriff bis einschließlich {date}",
  "No end date": "Kein Enddatum",
  "Remove read-only access": "Lesezugriff entfernen",
  "Read-only access given": "Lesezugriff gegeben",
  "No Edaptio account has that email. Create the user first.": "Es gibt kein Edaptio-Konto mit dieser E-Mail. Lege den Benutzer zuerst an.",
  "That person is already a member of the hold.": "Diese Person ist bereits Mitglied der Klasse.",
  "Read-only access removed": "Lesezugriff entfernt",
  "You have read-only access to this hold. You can look at everything, but not hand in, write or comment.": "Du hast Lesezugriff auf diese Klasse. Du kannst dir alles ansehen, aber nichts abgeben, schreiben oder kommentieren.",
  "View quiz": "Quiz ansehen",
  "You have read-only access: you can see the questions, but not answer them.": "Du hast Lesezugriff: Du kannst die Fragen sehen, aber nicht beantworten.",
  "Holds with read-only access": "Klassen mit Lesezugriff",
  "You no longer have access to this conversation": "Du hast keinen Zugriff mehr auf diese Unterhaltung",
}
